<script>
import GmapMarker from 'gmap-vue/dist/esm/components/marker-icon.vue'
import GmapMap from 'gmap-vue/dist/esm/components/map-layer.vue'
import getAddress from '@/modules/mixins/getAddress'
import mapOptions from '@/modules/mixins/mapOptions'

import { getGoogleMapsAPI } from 'gmap-vue'

export default {
    name: 'DeliveryMap',

    components: { GmapMarker, GmapMap },

    mixins: [getAddress, mapOptions],

    props: {
        pickup: null,
        dropoff: null,
        courier: null,
        updatedAt: null,
        visible: Boolean,
        fill: Boolean,
    },

    data() {
        return {
            mapZoom: 10,
            $geocoder: null,
            markerPickup: null,
            markerDropoff: null,
            markerCourier: null,
            map: null,
            timeout: null,
            testIndex: 0,
        }
    },

    computed: {
        google: getGoogleMapsAPI,
        showCourier() {
            return this.$store.getters['summary/showCourier']
        },
        config() {
            return this.$store.getters['site/config']
        },
    },
    watch: {
        courier: {
            deep: true,
            handler(position) {
                if (
                    position.lat &&
                    position.lng &&
                    (position.lat !== this.markerCourier?.position?.lat ||
                        position.lng !== this.markerCourier?.position?.lng)
                ) {
                    this.refreshMap(position)
                }
            },
        },
        showCourier(showCourier) {
            if (showCourier) this.initMap()
        },
        visible(visible) {
            if (visible) this.refreshMap(this.courier)
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.initMap()
        })
    },

    methods: {
        initMap() {
            Promise.all([this.getPosition('pickup'), this.getPosition('dropoff')]).then(
                (result) => {
                    result = { ...result[0], ...result[1] }
                    if (result.pickup)
                        this.markerPickup = {
                            position: result.pickup,
                            icon: '/images/marker-pickup.svg',
                            zIndex: 2,
                        }
                    if (this.showCourier && this.courier)
                        this.markerCourier = {
                            position: this.courier,
                            icon: '/images/marker-courier.svg',
                            zIndex: 3,
                        }
                    if (result.dropoff)
                        this.markerDropoff = {
                            position: result.dropoff,
                            icon: '/images/marker-dropoff.svg',
                            zIndex: 1,
                        }
                    this.refreshMap(this.markerCourier?.position)
                }
            )
        },
        async getPosition(position) {
            if (!this[position]) return {}
            if (this[position].lat && this[position].lng) return { [position]: this[position] }

            // if the address is not in lat-lng format, we have to get the coordinates form google api
            try {
                const result = await this.getAddress({
                    address: this[position],
                })
                return { [position]: result.geometry.location }
            } catch {
                return {}
            }
        },
        refreshMap(courierPosition) {
            if ((courierPosition?.lng || this.markerPickup) && this.markerDropoff) {
                this.$nextTick(() => {
                    let positions = [
                        this.markerDropoff.position,
                        courierPosition?.lng && this.showCourier
                            ? courierPosition
                            : this.markerPickup.position,
                    ]
                    positions.sort((a, b) => a.lng - b.lng)
                    this.$refs.map.$mapPromise.then((map) => {
                        let bounds = new this.google.maps.LatLngBounds(
                            new this.google.maps.LatLng(positions[0].lat, positions[0].lng),
                            new this.google.maps.LatLng(positions[1].lat, positions[1].lng)
                        )
                        if (this.markerCourier)
                            this.$set(this.markerCourier, 'position', courierPosition)
                        map.fitBounds(bounds, 120)
                    })
                })
            }
        },
    },
}
</script>

<template lang="pug">
.delivery-map-wrapper
    .delivery-map(:class="{'fill-map': fill}")
        .updated-at(v-if="updatedAt") {{updatedAt}}
        gmap-map(
            ref="map"
            v-if="markerCourier || markerPickup"
            :options="mapOptions"
            :center="(markerCourier && markerCourier.lat) || markerPickup.position"
            :zoom="10"
        )
            gmap-marker(
                v-if="markerPickup"
                :position="markerPickup.position"
                :z-index="markerPickup.zIndex"
                :icon="markerPickup.icon"
            )
            gmap-marker(
                v-if="markerDropoff"
                :position="markerDropoff.position"
                :z-index="markerDropoff.zIndex"
                :icon="markerDropoff.icon"
            )
            gmap-marker(
                v-if="markerCourier && markerCourier.position.lat && showCourier"
                :position="markerCourier.position"
                :z-index="markerCourier.zIndex"
                :icon="markerCourier.icon"
            )
</template>
